import * as React from 'react';

import { WorkSummaryStatus, WorkSummaryStatusLabel as _WorkSummaryStatusLabel } from '@acceligentllc/shared/enums/workSummaryStatus';

import styles from './styles.module.scss';

interface OwnProps {
	status: WorkSummaryStatus;
}

type Props = OwnProps;

const WorkSummaryStatusLabel: React.FC<Props> = (props) => {
	const { status } = props;
	const icon = status === WorkSummaryStatus.OUTDATED ? 'icon-dot_outline' : 'icon-dot';

	// Grey = default for DRAFT
	let colorClassName = styles.grey;
	if (status === WorkSummaryStatus.IN_PROGRESS || status === WorkSummaryStatus.OUTDATED) {
		colorClassName = styles.orange;
	} else if (status === WorkSummaryStatus.REVIEWED) {
		colorClassName = styles.blue;
	} else if (status === WorkSummaryStatus.COMPLETED) {
		colorClassName = styles.green;
	}

	return (
		<div className={styles.label}>
			<span className={`${icon} ${colorClassName} ${styles.icon}`} />
			{_WorkSummaryStatusLabel[status]}
		</div >
	);
};

export default WorkSummaryStatusLabel;
